module.exports = __webpack_public_path__ + "static/semplicita.light-e3d2f4d1553c63317e499316cc3d7bd2.otf";